import BaseViewHelper from 'js/view-helper/base';

export default class HilightFadeViewHelper extends BaseViewHelper {
  static hilight($tgt, delay = 100) {
    const c = 'hightlight-fade';
    $tgt.removeClass(c);
    setTimeout(() => $tgt.addClass(c), delay);
  }
}
